import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ExlyLoader from "ui/modules/ExlyLoader";
import {
  EXLY_WEBPAGE_DETAILS__SET_LISTINGS,
  EXLY_WEBPAGE_DETAILS__SET_SELECTED_SKU,
  EXLY_WEBPAGE_DETAILS__SET_SAVE_CTA,
  EXLY_WEBPAGE_DETAILS__SET_KEYWORDS,
  EXLY_WEBPAGE_DETAILS__SET_SAVED_REORDER_TYPE,
  EXLY_WEBPAGE_DETAILS__STOP_PROCESSING,
  EXLY_WEBPAGE_DETAILS__START_UPDATING,
} from "ui/pages/TemplatePreview/redux/actions";
import module_style from "../Style.module.css";
import { is_empty } from "utils/validations";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import UpdateName from "../Modals/UpdateName";
import dataProvider from "data/dataProvider";
import api from "data/APIs";
import { WebpageCreationContext } from "ui/pages/TemplatePreview";
import AccordianCard from "../Components/AccordianCard";
import { is_desktop } from "utils/Utils";
import CreateKeyword from "../Components/CreateKeyword";
import Backdrop from "@material-ui/core/Backdrop";
import { Checkbox, Modal } from "@material-ui/core";
import style from "../../../../../../../Style.module.css";
import { REORDERING } from "ui/pages/TemplatePreview/constants";
import Plan from "./Plan";
import RenderSkuListings from "./RenderSkuListings";
import RenderKeywordListings from "./RenderKeywordListings";
import AbsoluteLoader from "ui/modules/AbsoluteLoader";
import { ReorderTabs } from "features/ManageWebpage/modules/Customizations/common/utils/Customization.constants";
import { useCustomizationStore } from "features/ManageWebpage/modules/Customizations/store/useCustomizationStore";
import { logError } from "utils/error";

const form_data = {
  unassigned: "unassigned",
  listings: "listings",
  plans: "plans",
  SKU: "SKU",
  LISTING: "LISTING",
  KEYWORD: "KEYWORD",
};

const ListingType = () => {
  const dispatch = useDispatch();
  const listings_data = useSelector((state) => state.webpage_detail.listings);
  const keywords = useSelector((state) => state.webpage_detail.keywords);
  const processing = useSelector((state) => state.webpage_detail.processing);
  const updating = useSelector((state) => state.webpage_detail.updating);
  const saved_reordering_type = useSelector(
    (state) => state.webpage_detail.saved_reordering_type
  );

  const [edit_sku_title, set_edit_sku_title] = React.useState(false);
  const [add_keyword, set_add_keyword] = React.useState(false);
  const [edit_keyword_title, set_edit_keyword_title] = React.useState(false);
  const [order_by_keyword, set_order_by_keyword] = React.useState(
    saved_reordering_type === REORDERING.category_type.sku_keyword_listing_type
  );
  const [data, set_data] = React.useState([]);

  const { pushNotif } = React.useContext(WebpageCreationContext);

  const { setActiveReorderTab } = useCustomizationStore();

  React.useEffect(() => {
    if (add_keyword && !is_desktop) return;
    dispatch({
      type: EXLY_WEBPAGE_DETAILS__SET_SAVE_CTA,
      save_cta_text: "Save changes",
      handleSaveCta: handleSave,
    });

    setActiveReorderTab(ReorderTabs.OFFERING_TYPE);

    return () => setActiveReorderTab(null);
  }, [listings_data, keywords, order_by_keyword, add_keyword]);

  React.useEffect(() => {
    create_data();
  }, [order_by_keyword, edit_sku_title, keywords]);

  const create_data = () => {
    let temp;
    if (order_by_keyword) {
      temp = listings_data.listings_data?.sku_order.map((sku) => {
        let sku_keywords = keywords.map((item) => {
          let keywords_listing = listings_data.listings_data?.listings?.filter(
            (listing) => {
              if (listing.sku_type === sku) {
                if (is_empty(listing.keywords)) {
                  return false;
                }
                if (listing.keywords.includes(item.keyword)) return true;
                return false;
              } else {
                return false;
              }
            }
          );
          return {
            title: item.keyword,
            id: `sku_${sku}_keyword_${item.uuid}`,
            listings: keywords_listing,
          };
        });
        return {
          title: listings_data.listings_data?.sku_map?.listings[sku],
          id: `sku_${sku}`,
          sku: sku,
          keywords: sku_keywords,
        };
      });
    } else {
      temp = listings_data.listings_data?.sku_order.map((sku) => {
        let keywords_listing = listings_data.listings_data?.listings?.filter(
          (listing) => listing.sku_type === sku
        );
        return {
          title: listings_data.listings_data?.sku_map?.listings[sku],
          id: `sku_${sku}`,
          sku: sku,
          listings: keywords_listing,
        };
      });
    }

    set_data(temp);
  };

  const handleSave = async () => {
    try {
      dispatch({ type: EXLY_WEBPAGE_DETAILS__START_UPDATING });
      let listings = listings_data.listings_data.listings.map((item) => {
        return { uuid: item.listing_id, priority: item.priority };
      });
      if (!is_empty(listings))
        await dataProvider.custom_request(api.update_listing_priority, "POST", {
          listings: listings,
        });

      await dataProvider.custom_request(api.update_sku_priority, "POST", {
        listing_order: listings_data.listings_data?.sku_order,
      });

      let plans = listings_data.plans_data?.plans?.map((item) => {
        return {
          uuid: item.plan_uuid,
          priority: item.priority,
          heading: item.heading,
        };
      });
      if (!is_empty(plans)) {
        await dataProvider.custom_request(api.update_plan_priority, "POST", {
          plans: plans,
        });
        await dataProvider.custom_request(api.update_prepend_plan, "POST", {
          prepend_plans: listings_data.prepend_plans,
        });
      }

      let payload = keywords.map((item) => {
        return {
          uuid: item.uuid,
          sequence: item.sequence,
          keyword: item.keyword,
        };
      });
      await dataProvider.custom_request(api.update_keyword_priority, "POST", {
        keyword_sequences: payload,
      });

      let categorise_type = order_by_keyword
        ? REORDERING.category_type.sku_keyword_listing_type
        : REORDERING.category_type.sku_type;
      await dataProvider.custom_request(api.update_listing_category, "POST", {
        categorise_type: categorise_type,
      });
      dispatch({
        type: EXLY_WEBPAGE_DETAILS__SET_SAVED_REORDER_TYPE,
        payload: categorise_type,
      });
      pushNotif("Updated");
      dispatch({ type: EXLY_WEBPAGE_DETAILS__STOP_PROCESSING });
    } catch (err) {
      logError({
        error: err,
        occuredAt:
          "src/ui/pages/TemplatePreview/components/Sidebar/ListingReordering/ListingType/index.js",
        when: "saving data",
      });

      pushNotif(
        err?.body?.message ? err?.body?.message : "Something went wrong"
      );
      dispatch({ type: EXLY_WEBPAGE_DETAILS__STOP_PROCESSING });
    }
  };

  const addKeyword = (item, result) => {
    try {
      let keyword =
        item.keyword_uuid === form_data.unassigned
          ? item.keyword_uuid
          : keywords.filter((value) => value.uuid === item.keyword_uuid)[0]
              .keyword;
      let sku = item.sku;
      let output = listings_data;
      let listings = listings_data.listings_data.listings;
      const removed_listing = item.removed_listing;
      let sku_listings =
        keyword === form_data.unassigned
          ? listings.filter(
              (listing) =>
                listing.sku_type == sku &&
                is_empty(listing.keywords) &&
                listing.listing_id != removed_listing.listing_id
            )
          : listings.filter(
              (listing) =>
                listing.sku_type == sku &&
                listing.keywords.includes(keyword) &&
                listing.listing_id != removed_listing.listing_id
            );
      sku_listings.splice(result.destination.index, 0, removed_listing);
      for (let i = 0; i < sku_listings.length; i++) {
        let item = sku_listings[i];
        item.priority = sku_listings.length - i;
        listings.filter((listing, index) => {
          if (listing.listing_id === item.listing_id) {
            if (keyword !== form_data.unassigned)
              listing.keywords.push(keyword);
            listings.splice(index, 1);
          }
        });
      }
      listings.splice(listings.length, 0, ...sku_listings);
      output.listings_data.listings = listings;
      dispatch({ type: EXLY_WEBPAGE_DETAILS__SET_LISTINGS, payload: output });

      if (keyword !== form_data.unassigned)
        dataProvider.custom_request(api.add_keyword_listing, "POST", {
          keyword_uuid: item.keyword_uuid,
          entity_uuid: [item.listing_id],
        });
    } catch (err) {
      logError({
        error: err,
        occuredAt:
          "src/ui/pages/TemplatePreview/components/Sidebar/ListingReordering/ListingType/index.js",
        when: "adding keyword",
      });
      throw err;
    }
  };

  const removeKeyword = (item, result) => {
    try {
      if (!is_empty(item) && !is_empty(item?.keyword_uuid)) {
        let keyword =
          item.keyword_uuid === form_data.unassigned
            ? item.keyword_uuid
            : keywords.filter((value) => value.uuid === item.keyword_uuid)[0]
                .keyword;
        let sku = item.sku;
        let output = listings_data;
        let listings = listings_data.listings_data.listings;
        let sku_listings =
          keyword === form_data.unassigned
            ? listings.filter(
                (listing) =>
                  listing.sku_type == sku && is_empty(listing.keywords)
              )
            : listings.filter(
                (listing) =>
                  listing.sku_type == sku && listing.keywords.includes(keyword)
              );
        let removed_listing = sku_listings.splice(result.source.index, 1)[0];
        if (is_empty(removed_listing)) return;
        for (let i = 0; i < sku_listings.length; i++) {
          let item = sku_listings[i];
          item.priority = sku_listings.length - i;
          listings.filter((listing, index) => {
            if (listing.listing_id === item.listing_id) {
              listings.splice(index, 1);
            }
          });
        }
        if (keyword !== form_data.unassigned) {
          for (let listing of listings) {
            if (listing.listing_id === removed_listing.listing_id) {
              listing.keywords.splice(listing.keywords.indexOf(keyword), 1);
            }
          }
        }
        listings.splice(listings.length, 0, ...sku_listings);
        output.listings_data.listings = listings;
        dispatch({ type: EXLY_WEBPAGE_DETAILS__SET_LISTINGS, payload: output });

        if (keyword !== form_data.unassigned) {
          removed_listing.keywords.splice(
            removed_listing.keywords.indexOf(keyword),
            1
          );
          dataProvider.custom_request(api.remove_keyword_listing, "POST", {
            keyword_uuid: item.keyword_uuid,
            entity_uuid: item.listing_id ? item.listing_id : item.plan_uuid,
          });
        }
        return removed_listing;
      }
    } catch (err) {
      logError({
        error: err,
        occuredAt:
          "src/ui/pages/TemplatePreview/components/Sidebar/ListingReordering/ListingType/index.js",
        when: "removing keyword",
      });
      throw err;
    }
  };

  const handleKeywordListingDrag = (result, sku, keyword) => {
    let output = listings_data;
    let listings = listings_data.listings_data.listings;
    let sku_listings =
      keyword === form_data.unassigned
        ? listings.filter(
            (listing) => listing.sku_type == sku && is_empty(listing.keywords)
          )
        : listings.filter(
            (listing) =>
              listing.sku_type == sku && listing.keywords.includes(keyword)
          );
    const reordered_sku_listings = sku_listings.splice(result.source.index, 1);
    sku_listings.splice(result.destination.index, 0, ...reordered_sku_listings);
    for (let i = 0; i < sku_listings.length; i++) {
      let item = sku_listings[i];
      item.priority = sku_listings.length - i;
      listings.filter((listing, index) => {
        if (listing.listing_id === item.listing_id) {
          listings.splice(index, 1);
        }
      });
    }
    listings.splice(listings.length, 0, ...sku_listings);
    output.listings_data.listings = listings;
    dispatch({ type: EXLY_WEBPAGE_DETAILS__SET_LISTINGS, payload: output });
  };

  const handleListingDrag = (result, sku) => {
    let output = listings_data;
    let listings = listings_data.listings_data.listings;
    let sku_listings = listings.filter((listing) => listing.sku_type == sku);
    const reordered_sku_listings = sku_listings.splice(result.source.index, 1);
    sku_listings.splice(result.destination.index, 0, ...reordered_sku_listings);
    for (let i = 0; i < sku_listings.length; i++) {
      let item = sku_listings[i];
      item.priority = sku_listings.length - i;
      listings.filter((listing, index) => {
        if (listing.listing_id === item.listing_id) {
          listings.splice(index, 1);
        }
      });
    }
    listings.splice(listings.length, 0, ...sku_listings);
    output.listings_data.listings = listings;
    dispatch({ type: EXLY_WEBPAGE_DETAILS__SET_LISTINGS, payload: output });
  };

  const handleCrossKeywordListingDrag = async (result) => {
    try {
      let removed_listing;
      let source = result.source.droppableId.split(`_keyword_`);
      let destination = result.destination.droppableId.split(`_keyword_`);
      let sku = parseInt(source[0].split(`sku_`)[1]);
      removed_listing = removeKeyword(
        { keyword_uuid: source[1], listing_id: result.draggableId, sku },
        result
      );
      if (is_empty(removed_listing)) return;
      addKeyword(
        {
          keyword_uuid: destination[1],
          listing_id: result.draggableId,
          removed_listing,
          sku,
        },
        result
      );
    } catch (err) {
      logError({
        error: err,
        occuredAt:
          "src/ui/pages/TemplatePreview/components/Sidebar/ListingReordering/ListingType/index.js",
        when: "handleCrossKeywordListingDrag",
      });

      pushNotif(
        err?.body?.message ? err?.body?.message : "Something went wrong"
      );
    }
  };

  const handleDrag = (result) => {
    if (
      is_empty(result.destination) ||
      (result.destination.droppableId === result.source.droppableId &&
        result.destination.index === result.source.index)
    ) {
      return;
    }

    if (result.type === form_data.SKU) {
      let output = listings_data;
      let sku_order = listings_data.listings_data.sku_order;
      const reorderedSkus = sku_order.splice(result.source.index, 1);
      sku_order.splice(result.destination.index, 0, ...reorderedSkus);
      output.listings_data.sku_order = sku_order;
      dispatch({ type: EXLY_WEBPAGE_DETAILS__SET_LISTINGS, payload: output });
    } else if (result.type === form_data.LISTING) {
      if (result.source.droppableId.includes("keyword")) {
        // check if keyword based
        let source = result.source.droppableId.split(`_keyword_`);
        let destination = result.destination.droppableId.split(`_keyword_`);
        if (source[0] != destination[0]) return; // check if same sku
        if (source[1] == destination[1]) {
          // check if intra keyword
          let sku = parseInt(source[0].split(`sku_`)[1]);
          if (source[1] == form_data.unassigned) {
            // if intra unassigned listings
            handleKeywordListingDrag(result, sku, form_data.unassigned);
          } else {
            let keyword = keywords.filter((item) => item.uuid === source[1])[0]
              .keyword;
            handleKeywordListingDrag(result, sku, keyword);
          }
        }
        if (source[1] != destination[1]) {
          handleCrossKeywordListingDrag(result);
        }
      } else {
        // normal intra sku
        if (result.source.droppableId != result.destination.droppableId) return;
        let sku = parseInt(result.source.droppableId.split(`sku_`)[1]);
        handleListingDrag(result, sku);
      }
    } else if (result.type === form_data.KEYWORD) {
      let output = keywords;
      const reorderedKeyword = output.splice(result.source.index, 1);
      output.splice(result.destination.index, 0, ...reorderedKeyword);

      for (let i = 0; i < output.length; i++) {
        let item = output[i];
        item.sequence = i + 1;
      }
      dispatch({ type: EXLY_WEBPAGE_DETAILS__SET_KEYWORDS, payload: output });
    }

    create_data();
  };

  const renderListings = () => {
    return (
      <div className={``}>
        {!is_empty(data) && (
          <DragDropContext onDragEnd={handleDrag}>
            <Droppable droppableId="skus" type={form_data.SKU} mode="standard">
              {(provided) => {
                return (
                  <div ref={provided.innerRef}>
                    {data.map((item, index) => {
                      return (
                        <Draggable
                          key={item.id}
                          draggableId={item.id}
                          index={index}
                        >
                          {(provided) => (
                            <>
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                className={` bottom_margin`}
                              >
                                <AccordianCard
                                  item={item}
                                  title={item.title}
                                  provided={provided}
                                  handleEdit={() => {
                                    dispatch({
                                      type: EXLY_WEBPAGE_DETAILS__SET_SELECTED_SKU,
                                      sku: item.sku,
                                    });
                                    set_edit_sku_title(true);
                                  }}
                                >
                                  {order_by_keyword ? (
                                    <RenderSkuListings
                                      sku={item.sku}
                                      keywords={item.keywords}
                                      id={item.id}
                                      set_add_keyword={set_add_keyword}
                                    />
                                  ) : (
                                    <RenderKeywordListings
                                      id={item.id}
                                      listings={item.listings}
                                      set_add_keyword={set_add_keyword}
                                    />
                                  )}
                                </AccordianCard>
                              </div>
                              {provided.placeholder}
                            </>
                          )}
                        </Draggable>
                      );
                    })}
                    {provided.placeholder}
                  </div>
                );
              }}
            </Droppable>
          </DragDropContext>
        )}
      </div>
    );
  };

  if (!is_desktop && add_keyword)
    return (
      <CreateKeyword
        set_add_keyword={(value) => set_add_keyword(value)}
        add_keyword={add_keyword}
      />
    );

  return (
    <div className={`${module_style.container}`}>
      {updating && <AbsoluteLoader />}
      <div className={`${module_style.sub_heading} `}>
        Customize how offerings appear in your homepage
      </div>
      <div
        className={`${module_style.type_card_title} ${module_style.top_margin}`}
      >
        Categorize according to Offering type (Ex Workshops,1 on 1 Appointments
        etc.)
      </div>
      <div className="mt-2 mb-2">
        {processing || is_empty(data) ? (
          <ExlyLoader />
        ) : (
          <>
            {renderListings()}{" "}
            {listings_data.plans_data?.plans && (
              <Plan order_by_keyword={order_by_keyword} />
            )}{" "}
          </>
        )}
      </div>

      <div className={`mt-3 row no-gutters`} style={{ alignItems: "center" }}>
        <Checkbox
          color="primary"
          checked={order_by_keyword}
          onChange={() => {
            set_data([]);
            set_order_by_keyword(!order_by_keyword);
          }}
        />
        <div className={`${module_style.sub_heading} ml-2`}>
          Categorise by keyword
        </div>
      </div>

      {order_by_keyword && (
        <>
          <div
            onClick={() => set_add_keyword(true)}
            className={`mt-3 ${module_style.manage_keyword_cta} ${style.new_save_cta}`}
          >
            Manage keywords
          </div>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={is_desktop && add_keyword}
            onClose={() => {
              set_add_keyword(false);
            }}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <div className={`alert_modal ${style.modal}`}>
              <CreateKeyword
                set_add_keyword={(value) => set_add_keyword(value)}
                add_keyword={add_keyword}
              />
            </div>
          </Modal>
        </>
      )}

      {edit_sku_title && (
        <UpdateName
          type={"sku"}
          showModal={(value) => set_edit_sku_title(value)}
        />
      )}
      {edit_keyword_title && (
        <UpdateName
          type={"keyword"}
          showModal={(value) => set_edit_keyword_title(value)}
        />
      )}
    </div>
  );
};

export default ListingType;
